import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pie-graph",
  "use": "icon-pie-graph-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pie-graph\"><defs><style type=\"text/css\"></style></defs><path d=\"M65.2 512l64 0L512 512 512 129.2l0-64c-10-0.8-21.2-1.2-32-1.2C250.2 64 64 250.2 64 480 64 490.8 64.4 502 65.2 512z\" p-id=\"2284\" /><path d=\"M219.6 804.4C295.8 899.2 412.8 960 544 960c229.8 0 416-186.2 416-416 0-131.2-60.8-248.2-155.6-324.4C741 168.6 662 135.8 576 129.2L576 576 129.2 576C135.8 662 168.6 741 219.6 804.4z\" p-id=\"2285\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pie-graph.svg
// module id = B4AJ
// module chunks = 5